import { namespace } from 'vuex-class';
import { Module } from 'vuex';
import Action from './Action';
import Mutation from './Mutation';
import RootStoreState from '../RootStoreState';
import { DraggableSourcePayload } from './types';

export const dragAndDropNS = namespace('dragAndDrop');

export type SetItemAction = (payload: DraggableSourcePayload) => void;

export interface StoreState {
  payload: DraggableSourcePayload | null;
}
const getDragAndDropStore = (): Module<StoreState, RootStoreState> => ({
  namespaced: true,
  state: {
    payload: null,
  },
  actions: {
    [Action.SET_ITEM](
      { commit },
      payload: Parameters<SetItemAction>[0],
    ) {
      commit(Mutation.SET_PAYLOAD, payload);
    },
    [Action.CLEAR_ITEM]({ commit }) {
      commit(Mutation.SET_PAYLOAD, null);
    },
  },
  mutations: {
    [Mutation.SET_PAYLOAD](state, payload: DraggableSourcePayload) {
      state.payload = payload;
    },
  },
});

export default getDragAndDropStore;
